import React from 'react';
import {curry} from 'ramda';
import {QcJobStatuses} from '@pluto/@types';
import QCStatusToggle from './QCStatusToggle';

export interface QCStatusToggleProps {
    onPass: () => void;
    onFail: () => void;
    onReset: () => void;
    status: QcJobStatuses;
}

export default function QCStatusToggleContainer(props: QCStatusToggleProps) {
    const {status} = props;
    const onStatusChange = handleStatus(props);
    
    return (
        <QCStatusToggle
            onStatusChange={onStatusChange}
            status={status}
        />
    );
}

type StatusChangeEvent = React.MouseEvent<HTMLElement>;

export const handleStatus = curry((statusToggleActions: QCStatusToggleProps, event: StatusChangeEvent, newStatus: string) => {
    const {
        onPass,
        onFail,
        onReset,
    } = statusToggleActions;
    
    switch(newStatus) {
    case QcJobStatuses.Passed:
        onPass();
        break;
    
    case QcJobStatuses.Failed:
        onFail();
        break;
    
    default:
        onReset();
    }
});
